export default {
  instances: [],
  chosenInstances: [],
  refreshInstancesObject: [],
  selectedInstance: null,
  selectedInstanceObject: null,
  existsCloudConnection: false
}
